/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Home_Cta_MethodInputs */

const en_home_cta_method = /** @type {(inputs: Home_Cta_MethodInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Learn the Method`)
};

const es_home_cta_method = /** @type {(inputs: Home_Cta_MethodInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Conoce el método`)
};

const de_home_cta_method = /** @type {(inputs: Home_Cta_MethodInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lernen Sie die Methode`)
};

const zh_home_cta_method = /** @type {(inputs: Home_Cta_MethodInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`学习方法`)
};

const ar_home_cta_method = /** @type {(inputs: Home_Cta_MethodInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`تعرّف على المنهج`)
};

const fr_home_cta_method = /** @type {(inputs: Home_Cta_MethodInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Apprenez la méthode`)
};

const vi_home_cta_method = /** @type {(inputs: Home_Cta_MethodInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tìm hiểu phương pháp`)
};

const sw_home_cta_method = /** @type {(inputs: Home_Cta_MethodInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jifunze Mbinu`)
};

const th_home_cta_method = /** @type {(inputs: Home_Cta_MethodInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`เรียนรู้วิธีการ`)
};

const bs_home_cta_method = /** @type {(inputs: Home_Cta_MethodInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Učite metodu`)
};

const ja_home_cta_method = /** @type {(inputs: Home_Cta_MethodInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`方法を学ぶ`)
};

const ko_home_cta_method = /** @type {(inputs: Home_Cta_MethodInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`방법 알아보기`)
};

const pt_home_cta_method = /** @type {(inputs: Home_Cta_MethodInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aprenda o método`)
};

const it_home_cta_method = /** @type {(inputs: Home_Cta_MethodInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Scopri il metodo`)
};

const sv_home_cta_method = /** @type {(inputs: Home_Cta_MethodInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lär dig metoden`)
};

const nl_home_cta_method = /** @type {(inputs: Home_Cta_MethodInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`De methode leren`)
};

const da_home_cta_method = /** @type {(inputs: Home_Cta_MethodInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lær metoden`)
};

const nb_home_cta_method = /** @type {(inputs: Home_Cta_MethodInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lær metoden`)
};

const fi_home_cta_method = /** @type {(inputs: Home_Cta_MethodInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Opi menetelmä`)
};

const pl_home_cta_method = /** @type {(inputs: Home_Cta_MethodInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nauka metody`)
};

const ru_home_cta_method = /** @type {(inputs: Home_Cta_MethodInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Изучите метод`)
};

const tr_home_cta_method = /** @type {(inputs: Home_Cta_MethodInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yöntemi Öğrenin`)
};

const hi_home_cta_method = /** @type {(inputs: Home_Cta_MethodInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`विधि सीखिए`)
};

const id_home_cta_method = /** @type {(inputs: Home_Cta_MethodInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pelajari Metode`)
};

const ms_home_cta_method = /** @type {(inputs: Home_Cta_MethodInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pelajari Kaedah Ini`)
};

const cs_home_cta_method = /** @type {(inputs: Home_Cta_MethodInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Naučte se metodu`)
};

const el_home_cta_method = /** @type {(inputs: Home_Cta_MethodInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Μάθετε τη Μέθοδο`)
};

const he_home_cta_method = /** @type {(inputs: Home_Cta_MethodInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`הכירו את השיטה`)
};

const af_home_cta_method = /** @type {(inputs: Home_Cta_MethodInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Leer die metode`)
};

const hu_home_cta_method = /** @type {(inputs: Home_Cta_MethodInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ismerje meg a módszert`)
};

/**
* | output |
* | --- |
* | "Learn the Method" |
*
* @param {Home_Cta_MethodInputs} inputs
* @param {{ locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }} options
* @returns {LocalizedString}
*/
export const home_cta_method = /** @type {((inputs?: Home_Cta_MethodInputs, options?: { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home_Cta_MethodInputs, { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_home_cta_method(inputs)
	if (locale === "de") return de_home_cta_method(inputs)
	if (locale === "zh") return zh_home_cta_method(inputs)
	if (locale === "ar") return ar_home_cta_method(inputs)
	if (locale === "fr") return fr_home_cta_method(inputs)
	if (locale === "vi") return vi_home_cta_method(inputs)
	if (locale === "sw") return sw_home_cta_method(inputs)
	if (locale === "th") return th_home_cta_method(inputs)
	if (locale === "bs") return bs_home_cta_method(inputs)
	if (locale === "ja") return ja_home_cta_method(inputs)
	if (locale === "ko") return ko_home_cta_method(inputs)
	if (locale === "pt") return pt_home_cta_method(inputs)
	if (locale === "it") return it_home_cta_method(inputs)
	if (locale === "sv") return sv_home_cta_method(inputs)
	if (locale === "nl") return nl_home_cta_method(inputs)
	if (locale === "da") return da_home_cta_method(inputs)
	if (locale === "nb") return nb_home_cta_method(inputs)
	if (locale === "fi") return fi_home_cta_method(inputs)
	if (locale === "pl") return pl_home_cta_method(inputs)
	if (locale === "ru") return ru_home_cta_method(inputs)
	if (locale === "tr") return tr_home_cta_method(inputs)
	if (locale === "hi") return hi_home_cta_method(inputs)
	if (locale === "id") return id_home_cta_method(inputs)
	if (locale === "ms") return ms_home_cta_method(inputs)
	if (locale === "cs") return cs_home_cta_method(inputs)
	if (locale === "el") return el_home_cta_method(inputs)
	if (locale === "he") return he_home_cta_method(inputs)
	if (locale === "af") return af_home_cta_method(inputs)
	if (locale === "hu") return hu_home_cta_method(inputs)
	return en_home_cta_method(inputs)
});